const ageGate = () => {
    if (location.pathname.split("/")[2] === "unsubscribe") {
        return;
    }

    if (localStorage.getItem("age_confirmed")) {
        return;
    }

    const query = new URLSearchParams(location.search);
    if (query.get("age_confirmed")) {
        localStorage.setItem("age_confirmed", "1");
        return;
    }

    if (location.pathname.split("/")[2] !== "age-gate") {
        location.href =
            "/" +
            location.pathname.split("/")[1] +
            "/age-gate?" +
            query.toString();
        return;
    }
};

ageGate();
